module.exports = __webpack_public_path__ + "img/ALC072-1-EN.c36963c5.jpg";